import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { AuthStatus, useAuth } from '../auth';

import '../styles/dashboard.scss';

import { Modal } from 'bootstrap';

import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';


import NavBar from './navbar';
import Menu   from './menu';

const endpoint = process.env.REACT_APP_ENDPOINT;


const Dashboard = ()=>{
    const status = AuthStatus();
    const navigate = useNavigate();
    const { token } = useAuth();


    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState({});

    const [typeoff, setType] = useState([]);
    const [title , setTitle] = useState('');

    const [selectedType, setSelectedType] = useState('');

    const modalRef = useRef(null);
    let modalInstance = null;


    const contractTypes = [
        { value: "obra", label: "Contrato por obra determinada" },
        { value: "determinado", label: "Contrato por tiempo determinado" },
        { value: "indeterminado_capacitacion", label: "Contrato indeterminado con capacitación" },
        { value: "indeterminado_prueba", label: "Contrato indeterminado con prueba" },
        { value: "indeterminado_temporada", label: "Contrato indeterminado por temporada" },
        { value: "indeterminado", label: "Contrato por tiempo indeterminado" }
    ];

    const mixtsTypes = [
        { value: "reglamento", label: "Creación de reglamento interior de trabajo." },
        { value: "utilidades", label: "Participación de las y los trabajadores en las utilidades." },
        { value: "declaracion", label: "Exhibición y entrega de declaración anual." },
        { value: "proyecto", label: "Acta de proyecto de reparto de utilidades." },
        { value: "seguridad", label: "Seguridad e higiene en el trabajo." },
        { value: "capacitacion", label: "Capacitacion, productividad y adiestramiento." },
        { value: "antiguedad", label: "Determinar antiguedades."}

    ];

    const featuresTypes = [
        { value: 'programacion', label: "Constancia de Programación de Vacaciones"},
        { value: 'disfrute',     label: "Constancia de Disfrute de Vacaciones"},
        { value: 'diferir',      label: "Constancia de Solicitud de Vacaciones"},
        { value: 'paternidad',   label: "Constancia de Disfrute de Licencia por Paternidad"},
        { value: 'anticipo',     label: "Anticipo de Salario"}
    ];

    const demmitTypes = [
        { value: 'voluntaria', label: "Renuncia Voluntaria"},
        { value: 'embarazo',   label: "Renunca Mujer Embarazada"},
        { value: 'convenio',   label: "Convenio de Terminación Laboral"},
        { value: 'finiquito',  label: "Recibo de Finiquito"},
    ];



    const fetchCompanies = async () => {
        try {
            const response = await axios.get(`${endpoint}admin/companies`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setCompanies(response.data);
            console.log(response.data)
            if(response.data.length > 0){
                // verificar que todas las companies tengan un address 

                let allHaveAddress = true;
                for (const company of response.data) {
                    if (!company.addresses || company.addresses.length === 0 ) {    
                        allHaveAddress = false;
                        break;
                    }   
                }
                if (!allHaveAddress) {
                    toast.warn("Todas las empresas deben tener una dirección registrada. Actualiza la información para continuar.");
                    setTimeout(()=>{
                        navigate('/admin'); 
                    },5000);
                    return; // Salir de la función si alguna empresa no tiene dirección
                }

                setSelectedCompany(response.data[0]);
            }else{
                toast.warn("No tienes ninguna empresa registrada. Crea una para continuar.")
                setTimeout(()=>{
                    navigate('/admin'); 
                },4000);
            }
        } catch (error) {
            toast.error('Error al obtener la lista de companias')
        }
    };

    useEffect(()=>{
        fetchCompanies();

        if (modalRef.current) {
            modalInstance = new Modal(modalRef.current);
        }
        
        
    },[]);

    useEffect(()=>{
        if(typeoff.length > 0){
           new Modal(modalRef.current).show();
        };
        
    },[typeoff]);

    const handleItem = (options,title) =>{
        setType(options);
        setTitle(title);
    }
   

    const handleChangeType = (e) => {
        setSelectedType(e.target.value);

    };

    const handleCreateDocument = () => {
        
        if(selectedType === ''){
            toast.error("Selecciona un tipo para continuar");
            return;
        }else if(title === 'contrato'){
            
            navigate('/admin/contract',{ state: {new: selectedType} })
        }else if(title === 'comisión mixta'){
            navigate('/admin/mixts',{ state: {new: selectedType} })
        }else if(title === 'prestacion'){
            navigate('/admin/features', { state: {new: selectedType} })
        }else if(title === 'terminación laboral'){
            navigate('/admin/demmits', {state: {new: selectedType} })
        }

    };


    return(
        <div className="dashboard">
            <NavBar auth={status} companies={companies} selected={selectedCompany} set={setSelectedCompany}/>
            <div className='dashboard-row'>
                <Menu/>
                <div className="dashboard-wrapper">
                    <ToastContainer />
                    <div className="dashboard-grid">
                        <button className='dashboard-item -contract' onClick={()=>handleItem(contractTypes,'contrato')}>
                            Vamos a contratar a alguien? 
                        </button>
                        <button className='dashboard-item -report' onClick={()=>{navigate("/admin/contract", { state: {new: { value: "obra", label: "Contrato por obra determinada" }} });}}>
                            Algo salió mal con algun trabajador y lo quiero documentar? 
                        </button>
                        <button className='dashboard-item -rules' onClick={()=>{navigate("/admin/contract", { state: {new: { value: "obra", label: "Contrato por obra determinada" }} });}}>
                            Vamos a elaborar un reglamento? 
                        </button>
                        <button className='dashboard-item -fired' onClick={()=>{handleItem(demmitTypes,'terminación laboral');}}>
                            Terminó la relación laboral? 
                        </button>
                        <button className='dashboard-item -holidays' onClick={()=>{handleItem(featuresTypes, 'prestacion');}}>
                            Te pidieron vacaciones? 
                        </button>
                        <button className='dashboard-item -mixta' onClick={()=>handleItem(mixtsTypes,'comisión mixta')}>
                            Vamos a trabajar en comisiones mixtas? 
                        </button>
                        

                    </div>

                </div>
            </div>


            <div ref={modalRef} class="modal fade" id="createModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-centered">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Crear documento</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <label htmlFor="">Tipo de {title}</label>
                        <select 
                            id="contract-type"
                            className="form-control"
                            value={selectedType}
                            onChange={handleChangeType}
                        >
                            <option value="">Elige una opción</option>
                            {typeoff.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div class="modal-footer">
                       
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" onClick={handleCreateDocument}>Continuar</button>
                    </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Dashboard;